'use strict';

var propTypes = require('./prop-types.js');
require('@babel/runtime/helpers/defineProperty');
require('prop-types/factoryWithTypeCheckers');
require('./constants.js');

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
/**
 * Get the percentage of an element visibility.
 *
 * @function
 * @param {object} [parameter={}] - Object parameter.
 * @param {HTMLElement} [parameter.element] - Element to check.
 * @param {HTMLElement} [parameter.container] - Container element.
 * @returns {number} Returns the percentage (0-100) of the element visibility.
 * @example
 * getVisibilityPercentageOfElement({ element, container });
 * // => 42
 */

var getVisibilityPercentageOfElement = function getVisibilityPercentageOfElement() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      element = _ref.element,
      container = _ref.container;

  var visibilityPercentage = -1;

  if (element && container) {
    // ToDo: check left & right
    // ToDo2: check percentage based on top or bottom (-% / +%)
    var elementBoundingRect = element.getBoundingClientRect();
    var elementArea = elementBoundingRect.width * elementBoundingRect.height;
    var containerBoundingRect = {}; // Check the visibility of element relative to window (viewport)

    if (container.constructor === Window) {
      containerBoundingRect = {
        top: 0,
        bottom: window.innerHeight
      };
    } else {
      containerBoundingRect = container.getBoundingClientRect();
    }

    var outsideElementArea = 0;
    visibilityPercentage = 0;

    if (elementBoundingRect.top >= containerBoundingRect.top && elementBoundingRect.bottom <= containerBoundingRect.bottom && elementBoundingRect.top <= containerBoundingRect.bottom && elementBoundingRect.bottom <= containerBoundingRect.bottom) {
      // Inside container - Without intersection - 100% visibility
      outsideElementArea = 0;
    } else if (elementBoundingRect.top <= containerBoundingRect.top && elementBoundingRect.bottom <= containerBoundingRect.top || elementBoundingRect.top >= containerBoundingRect.bottom) {
      // Outside container - 0% visibility
      outsideElementArea = elementArea;
    } else if (elementBoundingRect.top >= containerBoundingRect.top && elementBoundingRect.bottom >= containerBoundingRect.bottom && elementBoundingRect.top <= containerBoundingRect.bottom && elementBoundingRect.bottom >= containerBoundingRect.bottom) {
      // Element bottom >= container bottom
      outsideElementArea = (elementBoundingRect.bottom - containerBoundingRect.bottom) * elementBoundingRect.width;
    } else if (elementBoundingRect.top <= containerBoundingRect.top && elementBoundingRect.bottom <= containerBoundingRect.bottom) {
      // Element top <= container top
      outsideElementArea = Math.abs((elementBoundingRect.top - containerBoundingRect.top) * elementBoundingRect.width);
    } else if (elementBoundingRect.top <= containerBoundingRect.top && elementBoundingRect.bottom >= containerBoundingRect.bottom) {
      // Element top >= container top && element bottom >= container bottom
      var outsideElementAreaBottom = (elementBoundingRect.bottom - containerBoundingRect.bottom) * elementBoundingRect.width;
      var outsideElementAreaTop = (elementBoundingRect.top - containerBoundingRect.top) * elementBoundingRect.width;
      outsideElementArea = outsideElementAreaBottom + outsideElementAreaTop;
    }

    visibilityPercentage = 100 - outsideElementArea * 100 / elementArea;
  }

  return visibilityPercentage;
};

getVisibilityPercentageOfElement.HELPER_ID = 'Gearz.JsUtils.getVisibilityPercentageOfElement';
getVisibilityPercentageOfElement.returnType = propTypes.numberWithDescription('Returns the percentage (0-100) of the element visibility.');
getVisibilityPercentageOfElement.parameterTypes = {
  parameter: propTypes.shapeWithDescription({
    element: propTypes.instanceOfWithDescription(HTMLElement, 'Element to check.'),
    container: propTypes.instanceOfWithDescription(HTMLElement, 'Container element.')
  }, 'Settings to get the visibility.')
};
getVisibilityPercentageOfElement.defaultParameters = {
  parameter: {}
};

module.exports = getVisibilityPercentageOfElement;
